import GenericArrayTreeNode from './GenericArrayTreeNode';
import ArrayWithRemove from './ArrayWithRemove';
import { nullArray } from './ArrayWithRemove';

export default class ArrayTreeNode extends GenericArrayTreeNode<ArrayWithRemove> {
	constructor () {
		super(ArrayWithRemove, nullArray);
	}
}
